import { useState } from 'react';
import { toast } from 'react-toastify';

import { SftpConnectionsApi } from '@/api/clients/sftp-connections/sftp-connections.api';
import { getFileNameFromDisposition } from '../components/fileImportFormatters';

export const useSftpConnectionImportDetail = ({
  organizationId,
  connectionId,
}) => {
  const [selectedImport, setSelectedImport] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const loadImportDetail = async (row) => {
    setSelectedImport(row);
    setDetailLoading(true);
    try {
      const response = await SftpConnectionsApi.getFileImport(
        organizationId,
        connectionId,
        row.id,
      );
      setSelectedImport(response.data.data);
    } catch (err) {
      toast.error(
        err.response?.data?.message || 'Failed to load import detail',
      );
    } finally {
      setDetailLoading(false);
    }
  };

  const downloadSourceFile = async () => {
    if (!selectedImport) return;

    setDownloadLoading(true);
    try {
      const response = await SftpConnectionsApi.downloadFileImportSourceFile(
        organizationId,
        connectionId,
        selectedImport.id,
      );
      const fileName = getFileNameFromDisposition(
        response.headers['content-disposition'],
        selectedImport.source_file_original_file_name ||
          selectedImport.source_file_name,
      );
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(
        err.response?.data?.message || 'Failed to download source file',
      );
    } finally {
      setDownloadLoading(false);
    }
  };

  return {
    selectedImport,
    detailLoading,
    downloadLoading,
    loadImportDetail,
    downloadSourceFile,
  };
};
